<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<template>
  <div>
    <h2>Templo mayor de Tenochtitlán.</h2>
    <model-fbx 
      src="galerias/tenochtitlan/g5m/templo_centrado.fbx"
            :rotation="rotation"
      :backgroundAlpha="0"
      :lights="lights"
      @on-load="onLoad"
      @on-mousemove="onMouseMove"
    >
    </model-fbx>
    <!-- <img @click="imageClicked(0)" src="galerias/tenochtitlan/g5m/MAQUETA_1_A.jpg" class="mainphoto"/> -->
    <p class="photo-description">Modelo tridimensional del Templo mayor de Tenochtitlán.</p>
    <p>Si deseas conocer más sobre este recinto visita: 
      <ul>
        <li><a target="_blank" href="https://www.templomayor.inah.gob.mx/">Templo mayor</a></li>
      </ul>
    </p>
  </div>
</template>

<script>
import { ModelFbx } from "vue-3d-model";

export default {
  name: "Sala1m5m",
  data() {
    return {
      rotation: {
        x: 0,
        y: 0,
        z: 0
      },
      lights: [
        {
          type: "HemisphereLight",
          position: { x: 0, y: 20, z: 0 },
          skyColor: 0xffffff, // 0xaaaaff,
          groundColor: 0xffffff, // 0x806060,
          intensity: 0.5,
        },
        {
          type: "DirectionalLight",
          position: { x: 0, y: 20, z: 20 },
          color: 0xffffff,
          intensity: 0.4,
        }
      ]
    };
  },
  methods: {
    imageClicked(idx) {
      this.$emit("onImageClicked", idx);
    },
    onLoad() {
      this.rotate();
    },
    rotate() {
      this.rotation.y += 0.001;
      requestAnimationFrame( this.rotate );
    },
    // eslint-disable-next-line no-unused-vars
    onMouseMove(event) {
      // console.log( event ); // event: { distance, face, faceIndex, point, index, uv, object }
    }
  },
  components: { ModelFbx },
  props: {},
  mounted() {},
};
</script>
